import {
    Footer,
    SpeakerContainer,
    SpeakerNameLabel,
    SpeakerNameWrapper,
    Strip,
    Triangle,
    TxtContainer,
    TxtWrapper,
    ImgWrapper,
    MouseImg,
    SpeakerTxtLabel,
    ChoiceBtnWrapper,
    ChoiceBtnsContainer
} from './style';
import ChoicesButton from '../generalButton/index.jsx';

export default (props) => {
    const { speakerName, speakerTxt, choicesBtns, firstBtnAction, secondBtnAction } = props;

    const fullText = speakerTxt?.split('\n').map((txt, index) => {
        return (
            <SpeakerTxtLabel key={ index }>
                { txt }
            </SpeakerTxtLabel>
        )
    });

    const choiceButtons = choicesBtns?.map((text, index) => {
        if(index) {
            return (
                <ChoiceBtnWrapper key={ index }>
                    <ChoicesButton 
                        key={ index }
                        txt={ text }
                        buttonAction={ secondBtnAction }
                        leftGradiant={'rgb(65, 105, 225)'}
                        rightGradiant={'rgb(135, 206, 235)'}
                        triangleHeight={'50px'}
                        markerHeight={'50px'}
                        sizeFont={'1.55rem'}
                        markerDeg={'27deg'} />
                </ChoiceBtnWrapper>
            )
        }

        return (
            <ChoiceBtnWrapper key={ index }>
                <ChoicesButton
                    key={ index }
                    txt={ text }
                    buttonAction={ firstBtnAction }
                    leftGradiant={'rgb(65, 105, 225)'}
                    rightGradiant={'rgb(135, 206, 235)'}
                    triangleHeight={'50px'}
                    markerHeight={'50px'}
                    sizeFont={'1.55rem'}
                    markerDeg={'27deg'} />
            </ChoiceBtnWrapper>
        )
    });

    return (
        <Footer>
            <SpeakerContainer>
                { speakerName && 
                <>
                    <SpeakerNameWrapper>
                        <SpeakerNameLabel>{ speakerName }</SpeakerNameLabel>
                        <Strip />
                    </SpeakerNameWrapper>
                    <Triangle />
                </>
                }
            </SpeakerContainer>
            <TxtContainer>
                <TxtWrapper>
                    { fullText }
                    { choiceButtons && <ChoiceBtnsContainer>{ choiceButtons }</ChoiceBtnsContainer> }
                </TxtWrapper>
                <ImgWrapper>
                    <MouseImg src={'assets/icons/mouse.webp'} />
                </ImgWrapper>
            </TxtContainer>
        </Footer>
    );
}